module.exports = __webpack_public_path__ + "static/media/599.7554(14).604982f3.pdf";